import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useFormattedUserListOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const ApproveModal = ({
  onSubmit,
  show = false,
  handleClose,
  locationCode,
  companyCode,
}) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();
  const userListOptions = useFormattedUserListOption({
    companyCode,
    locationCode,
  });

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Approve</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row">
            <div className="mb-3">
              <Input
                name="approvedBy"
                type="commonSelect"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Approved By"
                labelClassName="form-label"
                optionData={userListOptions}
                required={true}
                requiredMessage="Approved By is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("approvedBy", selectedOption);
                  trigger("approvedBy");
                }}
                defaultValue={watch("approvedBy")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="mb-3">
              <Input
                name="approvalDate"
                label="Approval Date"
                placeholder="User Group Code"
                className={`form-control ${
                  errors.approvalDate ? "is-invalid" : ""
                }`}
                labelClassName="form-label"
                type="text"
                required={true}
                dateFormat="YYYY-MM-DD"
                requiredMessage="Approval Date is requried"
              />
            </div>

            <div className="mb-3">
              <Input
                name="isApproved"
                type="commonSelect"
                placeholder="Status"
                className={`form-control ${
                  errors.isActive ? "is-invalid" : ""
                }`}
                label="Is Approved?"
                labelClassName="form-label"
                optionData={boolStatus}
                required={true}
                requiredMessage="Status is required"
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setValue("isApproved", selectedOption);
                  trigger("isApproved");
                }}
                defaultValue={watch("isApproved")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              Approve
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

ApproveModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  locationCode: PropTypes.string.isRequired,
  companyCode: PropTypes.any.isRequired,
};

export default ApproveModal;
